import {useState} from "react";
import {toast} from "react-toastify";
import {getQueryDataAsync} from "../../../../redux/AsyncActions/tsdb.async";
import {downloadCSV} from "../../../../service/downloadCSV";
import {formatCSV} from "../../../../service/formatCSV";

export const useDownloadAnalysisCSV = (analysis, name) => {
  const {properties = {}} = analysis;
  const {queries = []} = properties;
  const queryText = queries[0]?.text;
  const [isDownloading, setDownloading] = useState(false);

  const formatAndDownload = (data) => {
    if (data) {
      const formattedData = formatCSV(data);
      downloadCSV(formattedData, name);
    } else {
      downloadCSV("No Data Available", name);
    }
  };

  const handleDownload = async () => {
    if (queryText) {
      setDownloading(true);
      const payload = {
        query: queryText,
        timeRangeStart: "7d",
        windowPeriod: "3h",
      };
      try {
        const response = await getQueryDataAsync(payload);
        setDownloading(false);
        formatAndDownload(response?.data?.trim());
      } catch (e) {
        setDownloading(false);
      }
    } else {
      toast.error(`No data present for ${name}`);
    }
  };
  return {handleDownload, isDownloading};
};
